__turbopack_context__.v({
  "container": "controllerPlus-module-scss-module__60nP9q__container",
  "labelContainer": "controllerPlus-module-scss-module__60nP9q__labelContainer",
  "readOnlyLabel": "controllerPlus-module-scss-module__60nP9q__readOnlyLabel",
  "value": "controllerPlus-module-scss-module__60nP9q__value",
});
